import { Star, Quote, ExternalLink } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { REVIEW, BIZ } from "@/content";

const GoogleG = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-label="Google">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

const Stars = ({ size = "h-5 w-5" }) => (
  <div className="flex gap-1 text-[#FFB400]">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className={`${size} fill-current`} />)}</div>
);

export const Reviews = () => (
  <section id="reviews" className="bg-[#FAF9F6] py-24 lg:py-32" data-testid="reviews-section">
    <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Perth homeowners trust Plumberoo</Eyebrow>
        <h2 className="font-display text-4xl font-extrabold leading-[1] tracking-tight text-[#0F2B5B] sm:text-6xl">5-Star Google Rated</h2>
        <div className="mt-6 flex items-center gap-4">
          <span className="font-display text-6xl font-extrabold leading-none text-[#0F2B5B]" data-testid="reviews-rating">5.0</span>
          <div>
            <Stars size="h-6 w-6" />
            <p className="mt-1 text-sm text-slate-600" data-testid="reviews-count">Google rating</p>
          </div>
        </div>
        <p className="mt-6 max-w-md text-base text-slate-600 md:text-lg">Every job finished properly, explained in plain English, and left clean — that's what our customers keep telling Google.</p>
        <a href={BIZ.googleReviews} target="_blank" rel="noreferrer" data-testid="google-reviews-link"
          className="mt-8 inline-flex items-center gap-3 rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-[#0F2B5B] transition-[border-color,transform] hover:-translate-y-0.5 hover:border-[#FF6B00]">
          <GoogleG /> Read our reviews on Google <ExternalLink className="h-4 w-4 text-slate-500" />
        </a>
      </Reveal>
      <Reveal className="lg:col-span-7" delay={0.1}>
        <figure className="relative overflow-hidden rounded-[1.75rem] rounded-tr-[6rem] bg-[#0F2B5B] p-8 text-white shadow-[0_30px_70px_-30px_rgba(15,43,91,0.6)] sm:p-12" data-testid="review-card-0">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_0%,#2A8BEA_0%,transparent_55%)]" />
          <Quote className="absolute -right-6 -top-6 h-40 w-40 text-white/[0.06]" />
          <div className="relative">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-[#0F2B5B]"><GoogleG className="h-4 w-4" /> Google review</span>
              <Stars size="h-5 w-5" />
            </div>
            <blockquote className="font-display mt-8 text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-[2.1rem]">"{REVIEW.text}"</blockquote>
            <figcaption className="mt-8 flex items-center gap-4">
              <span className="grid h-12 w-12 place-items-center rounded-full bg-[#FF6B00] font-display text-lg font-extrabold">{REVIEW.author[0]}</span>
              <div>
                <p className="font-bold">{REVIEW.author}</p>
                <p className="text-sm text-[#FFB27A]">{REVIEW.location} · Verified customer</p>
              </div>
            </figcaption>
          </div>
        </figure>
      </Reveal>
    </div>
  </section>
);
